import { Component } from '@angular/core';
import { FeedbackPlatformReviewEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Reviews') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-feedbackplatformreview-form',
    templateUrl: './feedbackplatformreview.form.component.html'
})
export class FeedbackPlatformReviewFormComponent extends BaseFormComponent {
    public record!: FeedbackPlatformReviewEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'conversationsFeedbackPlatform', sectionName: 'Conversations__FeedbackPlatform', isExpanded: false },
            { sectionKey: 'reviewResponses', sectionName: 'Review Responses', isExpanded: false },
            { sectionKey: 'reviewThankYouNotes', sectionName: 'Review Thank You Notes', isExpanded: false }
        ]);
    }
}

